import { SharedHeader } from '../shared/SharedHeader';

/** Props for the LandingHeader overlay. */
interface ILandingHeaderProps {
  onLogo: () => void;
  onLogin: () => void;
  onDemo: () => void;
  onGetStarted: () => void;
}

/**
 * Pinned, translucent header overlay shown above every landing card.
 *
 * Delegates to the shared header with `homeStyle` enabled.
 *
 * @param props - Component props.
 * @returns The header overlay element.
 */
export function LandingHeader(props: ILandingHeaderProps) {
  return <SharedHeader homeStyle onLogo={props.onLogo} onLogin={props.onLogin} onDemo={props.onDemo} onGetStarted={props.onGetStarted} />;
}
